import { connect } from 'react-redux'

import { getGlobalVarsClients } from '../../../selectors/client'

import { makeAutobindedInput } from './FormBuilder'
import { SelectField } from './Select'
import { TextField } from './Text'

function ClientsSelectField_ ({ clients, value, extraOptions, ...rest }) {
  let options = clients.map(c => ({
    value: c.clientName,
    label: c.display,
    level: c.level || 2
  }))

  const isCurrentSystemClient = clients.find(c => c.clientName === value)

  let extraOptionsSelected

  if (extraOptions) {
    options = options.concat(extraOptions)

    extraOptionsSelected = !!extraOptions.find(o => o.value === value)
  }

  return isCurrentSystemClient || extraOptionsSelected || !value
    ? (
      <SelectField
        label='Client'
        {...rest}
        value={value}
        options={options}
      />
    )
    : (
      <TextField
        label='Client'
        {...rest}
        value={value}
        disabled
      />
    )
}

const mapStateToProps = redux => ({
  clients: getGlobalVarsClients(redux)
})

export const ClientsSelectField = connect(mapStateToProps)(ClientsSelectField_)

export const ClientsSelectInput = makeAutobindedInput(ClientsSelectField)
